import React from 'react'
import { formattedPhone, displayField } from '../../../utils/utils'
import { activeAdminLink } from '../../../helpers/navigationHelpers'
import TooltipGridRow from './TooltipGridRow'
import { Grid, Header } from 'semantic-ui-react'

export default class ShopTooltip extends React.Component {
  render() {
    const { id, name, main_phone_number, address_line1, city, state, zip } = this.props.shop
    const { local_appointment_datetime } = this.props.order
    const data = [
      { label: 'Name:', attr: name },
      { label: 'Phone:', attr: formattedPhone(main_phone_number) },
      { label: 'Address:', attr: address_line1 },
      {
        label: '',
        attr: `${displayField(city)}, ${displayField(state)} ${displayField(zip)}`
      },
      { label: 'Local Appt Time:', attr: local_appointment_datetime }
    ]

    return (
      <div style={{cursor: "auto"}}>
        <Header size='medium'>
          Shop
          <a href={activeAdminLink(`shops/${id}`)} rel='noopener noreferrer' target='_blank'>
            <small style={{paddingLeft: '5px'}}>(view)</small>
          </a>
        </Header>

        <Grid style={{width: "520px", paddingTop: '10px', paddingBottom: '20px'}}>
          <TooltipGridRow data={data} labelWidth={5} attrWidth={11} />
        </Grid>
      </div>
    )
  }
}
